import React from 'react';
import Head from '../../components/head';
import OpenGraphDescription from '../../components/OpenGraphDescription';
import OpenGraphTitle from '../../components/OpenGraphTitle';
import PageTitle from '../PageTitle';
import Section from '../Section';
import TextColumns from '../TextColumns';
// import styles from './styles'
import { Col, Row } from 'react-bootstrap';

const AboutUsDefaultContent: React.FC = () => (
  <>
    <Head slug='about' title={`Two Maids Professional Cleaning Services`} description='Our dedication to quality shines in everything we do, from ensuring our services are accessible to all to making every home brighter.'/>
    <OpenGraphTitle title={`Two Maids Professional Cleaning Services`} />

    <OpenGraphDescription>
      {/* Add About description here */}
      Our dedication to quality shines in everything we do, from ensuring our services are accessible to all to making every home brighter.
    </OpenGraphDescription>

    <Section>
      <>
        <Row
          className='justify-content-center'
          style={{ marginBottom: '200px' }}
        >
          <Col xs={12} md={12} lg={12} className='mb-5'>
            <div className='about-us-top-content'>
              <h1>About Us</h1>
              <h5>Two Maids prioritizes customer service and quality</h5>
              <p>
                At Two Maids, our goal is to make a difference in people's daily lives. We help busy families maintain beautiful, 
                clean and healthy homes and take care of the chores that no one has the time or energy to do. We proudly serve our 
                customers so they can focus on what matters most to them.
              </p>
              <p>
                Two Maids actively supports the "<a href='https://cleaningforareason.org/' target='_blank'>Cleaning for a Reason</a>" organization, which offers free housecleaning to people undergoing cancer treatment. Most of us have experienced cancer first-hand and we know that the kindness and service of others is a blessing that can provide some comfort and peace of mind in challenging times. Two Maids is proud to play a small part in that effort. We also partner with <a href='https://www.allianceforhope.com/' target='_blank'>Alliance for Hope International</a> to help provide support and care for survivors of domestic violence.
              </p>
              <p>
                At Two Maids, we endeavor to build dedicated and honest teams that looks forward to caring for your home. We know that providing our Professional House Cleaners with a growth plan, healthy compensation, and an environment that fosters encouragement and compassion will result in happier employees that can better meet or exceed our customers expectations.
              </p>
        
              <p>
                Two Maids cherishes the value people with disabilities bring to all aspects of life and we strive to ensure access to employment opportunities and our services where possible. We work diligently to align our websites and web applications with the latest Web Content Accessibility Guidelines (WCAG). We work to keep pace with these ever-evolving standards because we recognize their importance in making the digital world a more accessible environment for those with disabilities. <a href="/accessibility">View Accessibility Statement</a>.
              </p>
            </div>
            <div className='about-us-photo-container'>
              <img
                src={`https://res.cloudinary.com/twomaidsengi/image/upload/v1668793453/franchising-next/TwoMaids_15.webp`}
                alt='Ron Holt | CEO &amp; Founder of Two Maids'
              />
              <div
                className='about-us-circle'
                // style={{ marginBottom: '200px', marginTop: '200px' }}
              >
                <p>
                  Everything we do makes lives a little easier and homes a little brighter.
                </p>
                <p style={{ fontWeight: 'bold' }}>Shine On</p>
              </div>
            </div>{' '}
          </Col>
        </Row>
      </>
    </Section>
  </>
);

AboutUsDefaultContent.defaultProps = {
  // add AboutUsDefaultContent default props here
  className: null,
};

export default AboutUsDefaultContent;
